const QuizIcon = ({
  className = 'text-base-content',
  invert = false,
  ...props
}) => (
  <div
    className={className}
    style={{ filter: invert ? 'invert(100%)' : 'unset' }}
  >
    <svg
      width="23.999999999999996"
      height="23.999999999999996"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: 2 }}
    >
      <defs>
        <filter id="svg_1_blur">
          <feGaussianBlur stdDeviation="0" in="SourceGraphic" />
        </filter>
      </defs>
      <g>
        <title>Layer 1</title>
        <rect
          stroke="#fff"
          strokeWidth="0.5"
          filter="url(#svg_1_blur)"
          id="svg_1"
          height="3.20308"
          width="3.49427"
          y="2.42313"
          x="2.82515"
          fill="#ffffff"
        />
        <rect
          strokeWidth="0.5"
          stroke="#fff"
          id="svg_2"
          height="3.20565"
          width="3.49707"
          y="10.56908"
          x="2.7343"
          fill="none"
        />
        <line
          strokeWidth="1.5"
          id="svg_4"
          y2="3.74343"
          x2="22.41883"
          y1="3.74343"
          x1="9.99243"
          stroke="#fff"
          fill="none"
        />
        <line
          strokeWidth="1.5"
          id="svg_5"
          y2="12.20946"
          x2="22.48733"
          y1="12.20946"
          x1="10.06092"
          stroke="#fff"
          fill="none"
        />
        <line
          strokeWidth="1.5"
          id="svg_6"
          y2="20.30106"
          x2="22.33627"
          y1="20.30106"
          x1="9.90986"
          stroke="#fff"
          fill="none"
        />
        <path
          id="svg_7"
          d="m27.36392,20.36323l0.81283,-0.86888l0.86345,0.92299l0.86345,-0.92299l0.81283,0.86888l-0.86345,0.923l0.86345,0.923l-0.81283,0.86889l-0.86345,-0.923l-0.86345,0.923l-0.81283,-0.86889l0.86345,-0.923l-0.86345,-0.923z"
          stroke="#fff"
          fill="none"
        />
        <rect
          stroke="#fff"
          strokeWidth="0.5"
          id="svg_9"
          height="3.26843"
          width="3.56556"
          y="18.657"
          x="2.7343"
          fill="none"
        />
      </g>
    </svg>
  </div>
);

export default QuizIcon;
